var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadar6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 130,
    viewBox: "0 0 123 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1735 120.119C29.1045 120.119 2.91551 94.535 1.90051 62.708C1.02851 62.506 0.377502 61.729 0.377502 60.797C0.377502 27.273 27.6505 0 61.1735 0C62.1075 0 62.8835 0.650996 63.0845 1.522C94.9135 2.537 120.497 28.727 120.497 60.797C120.497 93.507 93.8855 120.119 61.1735 120.119ZM63.0555 2.504C62.8195 3.325 62.0715 3.93 61.1735 3.93C29.8195 3.93 4.3085 29.441 4.3085 60.797C4.3085 61.694 3.70451 62.443 2.88251 62.678C3.88151 93.978 29.6365 119.136 61.1735 119.136C93.3425 119.136 119.516 92.966 119.516 60.797C119.516 29.259 94.3545 3.503 63.0555 2.504ZM61.1735 74.779C53.4635 74.779 47.1915 68.507 47.1915 60.797C47.1915 53.087 53.4635 46.813 61.1735 46.813C68.8855 46.813 75.1585 53.087 75.1585 60.797C75.1585 68.507 68.8855 74.779 61.1735 74.779ZM61.1735 48.778C54.5485 48.778 49.1565 54.17 49.1565 60.797C49.1565 67.423 54.5485 72.814 61.1735 72.814C67.8015 72.814 73.1925 67.423 73.1925 60.797C73.1925 54.17 67.8015 48.778 61.1735 48.778Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 110C85.957 110 107 87.6139 107 60H60V110Z",
    fill: "#2E18EE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_1",
    x: 44,
    y: 48,
    width: 79,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0999163 0 0 0 0 0.0302041 0 0 0 0 0.721517 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadar6);
export default __webpack_public_path__ + "static/media/radar6.a88f9c5c3544bf880026bdc27cd821c9.svg";
export { ForwardRef as ReactComponent };